import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DiccionarioMilitarPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DiccionarioMilitarPage",
            
            ss: ss,
            ajax: {
                "url": ss.indexDiccionarioMilitar(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Termino', name: 'Termino', title: 'Término' },
                { data: 'Definicion', name: 'Definicion', title: 'Definición' },
                { data: 'Libro', name: 'Libro', title: 'Fuente' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            persona: {},

            diccionariomilitars: [],
            diccionariomilitar: {},

            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newDiccionarioMilitar() {
            this.diccionariomilitar = {};
            this.$refs['frm-diccionariomilitar'].show();
        },
        showDiccionarioMilitar(id) {
            this.isLoading=true;
            this.ss.showDiccionarioMilitar(id).then(
                (result) => {
                    let response = result.data;
                    this.diccionariomilitar = response.data;
                    this.$refs['view-diccionariomilitar'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDiccionarioMilitar() {
            this.$refs['frm-diccionariomilitar'].show();
            this.$refs['view-diccionariomilitar'].hide();
        },
        cancelDiccionarioMilitar() {
            if (this.unidadacademica.id) {
                this.$refs['view-diccionariomilitar'].show();
            }
            this.$refs['frm-diccionariomilitar'].hide();
        },
        saveDiccionarioMilitar() {
            this.ss.storeDiccionarioMilitar(this.diccionariomilitar).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-diccionariomilitar'].hide();
                    this.$refs['datatable-diccionariomilitar'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteDiccionarioMilitar() {
            this.$swal({
                title: "Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyDiccionarioMilitar(this.diccionariomilitar)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-diccionariomilitar'].hide();
                                this.$refs['datatable-diccionariomilitar'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-DiccionarioMilitar').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDiccionarioMilitar(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        this.persona = JSON.parse(localStorage.getItem('persona'));
        // if (!persona) {
        //   this.$router.push('/Login');
        // }
    }
};
